var shuffled = false;
    setInterval(function() {

        if(shuffled) {
            return;
        }

        try{
            var ul = document.querySelector('#product--grid');
            var lis = Array.from(ul.getElementsByClassName('productgrid--item'));

            for (var i = lis.length - 1; i > 0; i--) {
                var j = Math.floor(Math.random() * (i + 1));
                ul.insertBefore(lis[j], lis[i]);
            }
            shuffled = true;
        } catch {
           console.log('failed')
        }

    }, 1000)